module.exports = __webpack_public_path__ + "static/media/click.3fafd682.wav";